interface SaveStatusIndicatorProps {
  status: 'idle' | 'saving' | 'saved' | 'error';
}

export function SaveStatusIndicator({ status }: SaveStatusIndicatorProps) {
  if (status === 'idle') return null;

  const getStatusMessage = () => {
    switch (status) {
      case 'saving':
        return { 
          message: 'Saving your changes...', 
          className: 'bg-warning/10 border-warning/20 text-warning' 
        };
      case 'saved':
        return { 
          message: 'Changes saved successfully', 
          className: 'bg-success/10 border-success/20 text-success' 
        };
      case 'error':
        return { 
          message: 'Failed to save changes. Please try again.', 
          className: 'bg-destructive/10 border-destructive/20 text-destructive' 
        };
      default:
        return null;
    }
  };

  const statusInfo = getStatusMessage();
  if (!statusInfo) return null;

  return (
    <div 
      className={`save-status-indicator fixed top-5 right-5 px-4 py-3 rounded-lg border shadow-lg z-50 transition-all duration-300 ${statusInfo.className}`}
    >
      <span className="status-message text-sm font-medium">
        {statusInfo.message}
      </span>
    </div>
  );
}